import { combineReducers } from 'redux';
import socketReducer from './socketReducer';
import finalStateReducer from './finalStateReducer';

export default combineReducers({
    items: socketReducer,
  finalState: finalStateReducer,
});
